import React from 'react';
import { FaCalendarAlt, FaFileContract, FaExclamationTriangle } from 'react-icons/fa';

const TermsAndConditions = () => {
  return (
    <div style={styles.page}>

      {/* Navbar */}
      <nav style={styles.navbar}>
        <a href="/" style={styles.brand}>
          <FaCalendarAlt style={{ marginRight: 8, color: '#6366f1' }} />
          Meetify
        </a>
        <div style={styles.navLinks}>
          <a href="/login" style={styles.navLink}>Sign In</a>
          <a href="/login" style={styles.getStartedBtn}>Get Started</a>
        </div>
      </nav>

      {/* Hero */}
      <div style={styles.hero}>
        <div style={styles.heroIcon}>
          <FaFileContract size={28} color="#fff" />
        </div>
        <h1 style={styles.heroTitle}>Terms &amp; Conditions</h1>
        <p style={styles.heroSub}>
          Last updated: {new Date().toLocaleDateString('en-IN')}
        </p>
        <p style={styles.heroDesc}>
          By accessing or using Meetify, you agree to be bound by these Terms and Conditions. Please read them carefully.
        </p>
      </div>

      {/* Content */}
      <div style={styles.content}>

        {/* Important Notice */}
        <div style={styles.noticeBox}>
          <FaExclamationTriangle size={20} color="#92400e" style={{ marginRight: 10, flexShrink: 0, marginTop: 2 }} />
          <p style={{ margin: 0, color: '#92400e', fontSize: 14, lineHeight: 1.6 }}>
            <strong>Important:</strong> By using Meetify, you acknowledge that you have read, understood, and agree to these Terms.
            If you do not agree, please do not use our Service.
          </p>
        </div>

        <Section number="1" title="Description of Service">
          <p>
            Meetify is an online meeting scheduling software designed to help businesses plan, organize,
            and manage meetings efficiently.
          </p>
        </Section>

        <Section number="2" title="Eligibility">
          <p>
            You must be at least <strong>18 years old</strong> and have the authority to enter into contracts
            on behalf of your business to use Meetify.
          </p>
        </Section>

        <Section number="3" title="Account Registration">
          <p>
            To use our Service, you must create an account with accurate and complete information.
            You are responsible for:
          </p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activity that occurs under your account</li>
          </ul>
        </Section>

        <Section number="4" title="Subscription and Payments">
          <p>
            Meetify is offered on a <strong>monthly or yearly subscription</strong> basis. By subscribing, you agree to
            pay all fees associated with your chosen plan. Payments are processed securely through our payment partners.
          </p>
          <p>All prices are displayed in Indian Rupees (INR). Applicable taxes (such as GST) may be added.</p>
        </Section>

        <Section number="5" title="Refund and Cancellation Policy">
          <div style={styles.warningBox}>
            <strong>⚠️ No-Refund Policy:</strong> All subscription fees are strictly non-refundable.
          </div>
          <ul>
            <li>No refunds for unused subscription days, accidental purchases, or dissatisfaction.</li>
            <li>Cancellation stops future billing but does not entitle you to a refund for amounts already paid.</li>
            <li>Free Plan users are not charged, so no refund is applicable.</li>
          </ul>
          <p>We recommend evaluating our <strong>Free Plan</strong> before upgrading to a paid subscription.</p>
        </Section>

        <Section number="6" title="Acceptable Use">
          <p>You agree <strong>not</strong> to:</p>
          <ul>
            <li>Use the Service for any illegal or unauthorized purpose</li>
            <li>Interfere with or disrupt the platform's performance</li>
            <li>Attempt to gain unauthorized access to any part of the system or user data</li>
          </ul>
          <p>We reserve the right to suspend or terminate accounts that violate these terms.</p>
        </Section>

        <Section number="7" title="Data and Privacy">
          <p>
            By using Meetify, you agree that we may store and process your business and meeting-related data.
            We take reasonable measures to protect it; however, users are responsible for maintaining their own data backups.
          </p>
          <p>
            Please refer to our <a href="/PrivacyPolicy" style={styles.link}>Privacy Policy</a> for full details on how we handle data.
          </p>
        </Section>

        <Section number="8" title="Intellectual Property">
          <p>
            All content, trademarks, logos, and software provided through Meetify are the intellectual property of Meetify
            and may not be copied, modified, or distributed without prior written consent.
          </p>
        </Section>

        <Section number="9" title="Disclaimer of Warranties">
          <p>
            Meetify is provided on an <strong>"as is"</strong> and <strong>"as available"</strong> basis.
            We do not guarantee uninterrupted access, error-free performance, or that the Service will meet all your expectations.
          </p>
        </Section>

        <Section number="10" title="Limitation of Liability">
          <p>
            To the maximum extent permitted by law, Meetify shall not be liable for any indirect, incidental,
            or consequential damages arising from your use of the Service.
          </p>
        </Section>

        <Section number="11" title="Termination">
          <p>
            We may suspend or terminate your access if you violate these Terms or misuse the platform.
            You may also terminate your account at any time by contacting us.
          </p>
        </Section>

        <Section number="12" title="Changes to Terms">
          <p>
            We may update these Terms periodically. Continued use of Meetify after changes are made means
            you accept the updated Terms.
          </p>
        </Section>

        {/* Contact Box */}
        <div style={styles.contactBox}>
          <h3 style={styles.contactTitle}>Questions? Contact Us</h3>
          <p style={styles.contactDesc}>
            If you have any questions about these Terms, reach out to our team:
          </p>
          <div style={styles.contactList}>
            <div>
              <strong>Meetify Support</strong><br />
              <a href="mailto:meetify.co.in@gmail.com" style={styles.contactLink}>meetify.co.in@gmail.com</a>
            </div>
            <div>
              <strong>Rishabh Mandal</strong><br />
              <a href="mailto:Mandalrishabh60@yahoo.com" style={styles.contactLink}>Mandalrishabh60@yahoo.com</a>
            </div>
            <div>
              <strong>Nitesh Mandal</strong><br />
              <a href="mailto:Niteshmandal007@yahoo.com" style={styles.contactLink}>Niteshmandal007@yahoo.com</a>
            </div>
          </div>
        </div>

      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div style={styles.footerBrand}>
            <FaCalendarAlt style={{ marginRight: 6, color: '#6366f1' }} />
            <strong>Meetify</strong>
          </div>
          <p style={styles.footerCopy}>© {new Date().getFullYear()} Meetify. All rights reserved.</p>
        </div>
        <div>
          <a href="/PrivacyPolicy" style={styles.footerLink}>Privacy</a>
          <a href="/TermsAndConditions" style={styles.footerLink}>Terms</a>
          <a href="/helpcenter" style={styles.footerLink}>Contact</a>
        </div>
      </footer>

    </div>
  );
};

const Section = ({ number, title, children }) => (
  <div style={styles.section}>
    <div style={styles.sectionHeader}>
      <span style={styles.sectionNumber}>{number}</span>
      <h2 style={styles.sectionTitle}>{title}</h2>
    </div>
    <div style={styles.sectionBody}>{children}</div>
  </div>
);

const styles = {
  page: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    color: '#1e293b',
    background: '#f8fafc',
    minHeight: '100vh',
  },

  // Navbar
  navbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 40px',
    background: '#fff',
    borderBottom: '1px solid #e2e8f0',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  brand: {
    fontWeight: 700,
    fontSize: 22,
    color: '#1e293b',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  navLink: {
    color: '#475569',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
  },
  getStartedBtn: {
    background: '#6366f1',
    color: '#fff',
    padding: '7px 16px',
    borderRadius: 8,
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 600,
  },

  // Hero
  hero: {
    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    color: '#fff',
    textAlign: 'center',
    padding: '56px 20px 48px',
  },
  heroIcon: {
    background: 'rgba(255,255,255,0.15)',
    width: 56,
    height: 56,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  heroTitle: {
    fontSize: 36,
    fontWeight: 800,
    margin: '0 0 8px',
  },
  heroSub: {
    fontSize: 13,
    opacity: 0.8,
    margin: '0 0 16px',
  },
  heroDesc: {
    fontSize: 16,
    opacity: 0.9,
    maxWidth: 520,
    margin: '0 auto',
    lineHeight: 1.6,
  },

  // Content
  content: {
    maxWidth: 760,
    margin: '0 auto',
    padding: '40px 20px 60px',
  },

  // Notice Box
  noticeBox: {
    display: 'flex',
    alignItems: 'flex-start',
    background: '#fffbeb',
    border: '1px solid #fcd34d',
    borderRadius: 10,
    padding: '14px 18px',
    marginBottom: 24,
  },

  // Warning Box (inside section)
  warningBox: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: 8,
    padding: '10px 14px',
    color: '#991b1b',
    marginBottom: 12,
    fontSize: 14,
  },

  // Section
  section: {
    background: '#fff',
    borderRadius: 12,
    padding: '28px 32px',
    marginBottom: 20,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    borderLeft: '4px solid #6366f1',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 14,
  },
  sectionNumber: {
    background: '#6366f1',
    color: '#fff',
    borderRadius: '50%',
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: 13,
    flexShrink: 0,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    margin: 0,
    color: '#1e293b',
  },
  sectionBody: {
    fontSize: 15,
    lineHeight: 1.7,
    color: '#475569',
  },

  link: {
    color: '#6366f1',
    textDecoration: 'none',
  },

  // Contact Box
  contactBox: {
    background: '#6366f1',
    color: '#fff',
    borderRadius: 12,
    padding: '36px 32px',
    textAlign: 'center',
    marginTop: 32,
  },
  contactTitle: {
    fontSize: 22,
    fontWeight: 700,
    margin: '0 0 8px',
  },
  contactDesc: {
    opacity: 0.85,
    marginBottom: 24,
    fontSize: 15,
  },
  contactList: {
    display: 'flex',
    justifyContent: 'center',
    gap: 40,
    flexWrap: 'wrap',
    fontSize: 15,
    lineHeight: 1.8,
  },
  contactLink: {
    color: '#c7d2fe',
    textDecoration: 'none',
  },

  // Footer
  footer: {
    background: '#1e293b',
    color: '#94a3b8',
    padding: '20px 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
  },
  footerInner: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  footerBrand: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    fontWeight: 700,
    fontSize: 16,
  },
  footerCopy: {
    margin: 0,
    fontSize: 13,
  },
  footerLink: {
    color: '#94a3b8',
    textDecoration: 'none',
    marginLeft: 20,
    fontSize: 13,
  },
};

export default TermsAndConditions;